<template>
  <div class="right-sidebar elevation-2">
    <v-layout class="mt-2" column justify-start align-center>
      <right-sidebar-button v-if="currentTab === null" icon="chevron_left" @openTab="openTab('layers')" />
      <right-sidebar-button v-if="currentTab === 'layers' || currentTab === 'tools'" icon="chevron_right" @openTab="openTab(null)" />
      <right-sidebar-button icon="layers" @openTab="openTab('layers')" />
      <right-sidebar-button icon="construction" @openTab="openTab('tools')" />
    </v-layout>
  </div>
</template>

<script>
import RightSidebarButton from "@/components/Network/RightSidebar/RightSidebarButton";
import { mapActions } from "vuex";
export default {
  name: "RightSidebarClose",

  components: { RightSidebarButton },

  data() {
    return {
      currentTab: this.$store.getters.getCurrentlyOpenTabSidebar
    }
  },

  methods: {
    ...mapActions(["setOpenTabSidebar"]),

    /**
     * Open the selected tab
     * @param tab
     */
    openTab(tab) {
      this.setOpenTabSidebar(tab);
      this. currentTab = this.$store.getters.getCurrentlyOpenTabSidebar
    }
  }
};
</script>

<style scoped>
.right-sidebar {
  position: absolute;
  width: 45px;
  height: 100%;
  z-index: 10;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/RightSidebar/RightSidebarClose.vue